/* =========================================================================
   Pizzamateur — Refus définitif du popup e-mail

   PROBLÈME
   Dans custom-polish.js, fermer le popup n'écrit que :
       sessionStorage.setItem('pizzamateur_popup_closed', 'true')
   Le refus ne vaut donc que pour l'onglet en cours : le popup revient à
   la visite suivante, même après un « Je refuse le cadeau » explicite.
   C'est vécu comme du forcing.

   SOLUTION
   custom-polish.js sait déjà lire une clé permanente :
       localStorage.getItem('pizzamateur_popup_seen') === 'true'  -> ne s'ouvre pas
   Il suffit donc d'écrire cette clé au clic sur « Je refuse le cadeau ».

   POURQUOI UN FICHIER SÉPARÉ PLUTÔT QUE MODIFIER custom-polish.js
   Ce dernier est minifié sur une seule ligne (~9 700 caractères) et pilote
   aussi les badges produit, le bandeau cookies et le popup lui-même. Le
   réécrire intégralement pour deux mots ferait courir un risque sans
   commune mesure avec le gain. Ce fichier-ci est additif et réversible :
   il suffit de retirer la ligne correspondante de layout/theme.liquid.

   PORTÉE VOLONTAIREMENT ÉTROITE
   Seul le bouton « Je refuse » rend le refus définitif. La croix de
   fermeture garde le comportement actuel (session), car fermer n'est pas
   refuser : on peut fermer par réflexe et vouloir l'offre plus tard.
   ========================================================================= */

(function () {
  'use strict';

  function memoriserRefus() {
    try {
      localStorage.setItem('pizzamateur_popup_seen', 'true');
    } catch (e) {
      /* navigation privée ou stockage bloqué : on ne casse rien */
    }
  }

  // Capture : on note le refus avant que le popup ne soit retiré du DOM.
  document.addEventListener(
    'click',
    function (evenement) {
      var cible = evenement.target;
      if (!cible || typeof cible.closest !== 'function') return;

      var bouton = cible.closest('#pizzamateur-popup button, #pizzamateur-popup a');
      if (!bouton) return;

      var libelle = (bouton.textContent || '').toLowerCase();
      if (libelle.indexOf('refuse') === -1) return;

      memoriserRefus();
    },
    true
  );
})();
